const StudentSymposiumWinnersList: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <section className="mb-8">
                <p className="mb-2">
                    Selamat kepada Para Pemenang <b>Student Symposium</b> di <b>IIT Challenge 2024</b>! Kompetisi ini menjadi wadah bagi pelajar dan mahasiswa untuk mempresentasikan hasil penelitian atau gagasan ilmiah dalam suasana akademik yang profesional.
                </p>

                <p className="mb-4 font-semibold">Kenapa Ini Pengalaman Berharga?</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>🗣️ <b>Latihan Presentasi Ilmiah:</b> Mengasah keterampilan komunikasi akademik.</li>
                    <li>🎯 <b>Feedback dari Ahli:</b> Mendapat masukan langsung dari para juri dan akademisi.</li>
                    <li>🌐 <b>Networking Peneliti Muda:</b> Bertemu dengan pemikir muda dari seluruh Indonesia.</li>
                </ul>

                <p className="mb-3 font-semibold">🎖️ Pemenang Student Symposium IIT Challenge 2024</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>
                        <p className="mb-2 font-semibold">🥇 Juara 1 – Tim Ferro Tech</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Yehezkiel Michael Laysander</li>
                            <li className="font-semibold">• Marvino Aloysius Tjondro</li>
                            <p><i>(SMA Kristen Petra 2)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥈 Juara 2 – Tim SMAK KKGG</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Nathan Alexander Lim</li>
                            <li className="font-semibold">• Davien Erwin Ignatius</li>
                            <li className="font-semibold">• Rayden Immanuel Setiawan</li>
                            <li className="font-semibold">• Christofer Hansel</li>
                            <p><i>(Sekolah Kristen Kalam Kudus Green Garden)</i></p>
                        </ul>
                    </li>
                    <li>
                        <p className="mb-2 font-semibold">🥉 Juara 3 – Tim Monyet Jawa</p>
                        <ul className="ml-8">
                            <li className="font-semibold">• Muhammad Abufadhi Abbas</li>
                            <li className="font-semibold">• Ahmad Bayu</li>
                            <li className="font-semibold">• Zahwa Aqilah Mu’tazzah</li>
                            <li className="font-semibold">• Gina Mahrin Ratifah</li>
                            <p><i>(MAN 2 Jakarta)</i></p>
                        </ul>
                    </li>
                </ul>

                <p className="mb-4 font-semibold">🎁 Hadiah & Manfaat Eksklusif</p>
                <p className="mb-3">Selain medali dan sertifikat, pemenang berhak atas:</p>
                <ul className="list-disc pl-6 mb-4">
                    <li>✅ Software Programming Bootcamp (2 Bulan) – Rp 26.550.000</li>
                    <li>✅ Robotic Race & Software Programming Workshop – Persiapan WIT Challenge 2024</li>
                    <li>✅ Subsidi Pendaftaran WIT Challenge 2024</li>
                </ul>

                <p className="mb-3 font-semibold">🎓 Beasiswa UKRIDA</p>
                <ul className="list-disc pl-6 mb-4">
                    <li><b>Juara 1:</b> Beasiswa penuh (SPP + uang pangkal) hingga 8 semester di Teknik Elektro, Industri, atau Sipil (IPK ≥ 3.00). Prodi lain: Gratis uang pangkal + diskon 25% SPP.</li>
                    <li><b>Juara 2:</b> Gratis uang pangkal 100% untuk semua prodi.</li>
                    <li><b>Juara 3:</b> Diskon 70% uang pangkal untuk semua prodi.</li>
                    <li><b>Semua Juara:</b> Biaya pangkal Kedokteran khusus Rp 200.000.000 (kuota Ukridian&apos;s Family, syarat berlaku).</li>
                </ul>

                <p className="mb-2 font-semibold">📝 Siap Tampil di Forum Akademik?</p>
                <p className="mb-2">Jadikan idemu dikenal lebih luas. Siapkan paper-mu dan ikuti simposium berikutnya!</p>

                <p className="font-semibold">
                    📸 Lihat dokumentasi dan highlights di Instagram <a className="text-blue-500" href="https://www.instagram.com/iitchallenge2024/" target="_blank">@iitchallenge2024</a>
                </p>
            </section>
        </div>
    )
}
export default StudentSymposiumWinnersList